import React from "react";
import PropTypes from "prop-types";
import { Select, Space } from "antd";
import classes from "./SelectDropdown.module.css";

const renderOption = (option) => (
  <Space>
    <span>{option.data.label}</span>
  </Space>
);

export const SelectDropdown = ({
  menuOptions,
  placeholder = "select",
  value,
  onChange,
  disabled = false,
  widthSize = "18rem",
}) => {
  const handleChange = (selectedValue) => {
    if (onChange) onChange(selectedValue);
  };

  return (
    <Select
      className={classes["select-dropdown"]}
      mode="single"
      onChange={handleChange}
      value={value}
      placeholder={placeholder}
      optionLabelProp="label"
      disabled={disabled}
      options={menuOptions}
      style={{
        width: widthSize,
      }}
      optionRender={renderOption}
    />
  );
};

SelectDropdown.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      disabled: PropTypes.bool,
    }),
  ),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  widthSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
